import { boolean, mixed, object, string } from 'yup';

import type { IImage } from '@/types/image';

const clientValidationSchema = object({
  name: string().required().label('Client name'),
  address: string().optional().label('Address'),
  phone: string().optional().label('Phone number'),
  // The API validates these as email addresses, so catch it here rather than
  // letting a typo come back as a 400.
  senderEmail: string().email().optional().label('Sender email'),
  contactEmail: string().email().optional().label('Contact email'),
  replyToEmail: string().email().optional().label('Reply email'),
  senderName: string().max(100).optional().label('Email sender name'),
  // Only on the edit form; "Add client" leaves it to the API default (off).
  twoFactorEnabled: boolean().optional().label('Two-factor authentication'),
  // Edit form only, like 2FA; a new client starts outside the beta group.
  isBetaTester: boolean().optional().label('Beta tester'),
});

/**
 * "Add client" — the edit form's fields plus the logo, which is create-only:
 * the API puts it on the new tenant's company detail, and from then on it is
 * the tenant's to change.
 */
const clientCreateValidationSchema = clientValidationSchema.shape({
  // The dropzone's own shape, left as-is — the cast to the filename the API
  // wants happens in `toCreatePayload`.
  logo: mixed<IImage[]>().optional().label('Logo'),
});

export { clientValidationSchema, clientCreateValidationSchema };
